import * as Yup from 'yup';

import { ACCOUNT_TYPES_1, ACCOUNT_TYPES_2 } from 'utils/helpers';

export const nonQbAccountsInitialValues = (accounts) => ({
    accounts: accounts.map((account) => ({
        id: account.id,
        name: account.official_name,
        mask: account.mask,

    })),
});


export const nonQbAccountsSchema = Yup.object().shape({
    accounts: Yup.array().of(
        Yup.object().shape({
            name: Yup.string().required('Account name is required'),
            mask: Yup.string().required('Mask number is required'),
            
        }),
    ),
});
